import React from 'react';
import { Button, CustomSelect, CustomSelectItem, LabeledValue, LoadingData } from '@hwm/ui-lib';
import { useState } from 'react';
import { t, Trans } from '@lingui/macro';
import { useGraphExportDataSource } from './graphExportDataSource';
import { useEffect } from 'react';

import { isEmpty } from 'lodash';
import { BaseExportType, GraphExportType } from '@shared/models';
import { DialogModal } from '@shared/components';
import { Collapse, makeStyles, Theme } from '@material-ui/core';
import { useFiltersContext } from '@shared/components/Filters/useFiltersContext';

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    height: 36,
    maxHeight: 36,
    width: 180,
    maxWidth: 180,
    zIndex: 200,
    marginRight: theme.spacing(2),
    '& .select__control': {
      minWidth: 108,
    },
    [theme.breakpoints.down('xs')]: {
      width: 160,
      maxWidth: 160,
    },
  },
  labeledValue: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
}));

interface GraphExportProps {
  pmzId: number;
}

export const GraphExport: React.FC<GraphExportProps> = ({ pmzId }) => {
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);
  const [exportSelector, setExportSelector] = useState<GraphExportType>(null);

  const { graphState, sharedState } = useFiltersContext();

  const {
    // TODO: uncomment when API is ready
    // getExportFormats,
    getExportData,
    exportFormats,
    loading,
    exportLoading,
  } = useGraphExportDataSource();

  // TODO: uncomment when API is ready
  // useEffect(() => {
  //   if (!exportFormats || isEmpty(exportFormats)) {
  //     getExportFormats();
  //   }
  // }, [showModal, exportFormats, getExportFormats]);

  useEffect(() => {
    if (showModal && !exportSelector && exportFormats && !isEmpty(exportFormats)) {
      const data = exportFormats?.find((el) => el === BaseExportType.CSV) ?? exportFormats[0];
      setExportSelector(data);
    }
  }, [showModal, exportFormats, exportSelector]);

  // const mainBtnDisabled = useMemo(
  //   () => !exportFormats || isEmpty(exportFormats),
  //   [exportFormats]
  // );

  return (
    <>
      {/* <Button
        style={{
          height: 28,
          padding: 8,
        }}
        onClick={() => setShowModal(true)}
        disabled={mainBtnDisabled}
      >
        <Trans>Export</Trans>
      </Button> */}
      <DialogModal show={showModal} setShow={setShowModal} headerTitle={t`Graph Export`} headerDivider>
        <>
          {loading && <LoadingData />}
          <Collapse in={!loading}>
            <div className="flex flex-col m-2 -mb-2">
              <LabeledValue label={t`Data`} className={classes.labeledValue}>
                <div className="flex items-center sm:ml-2">
                  <CustomSelect
                    label={null}
                    placeholder={t`Select file type`}
                    onChange={(selectedValue) => setExportSelector((selectedValue as CustomSelectItem).value)}
                    options={exportFormats?.map((exportFormat) => ({
                      label: exportFormat,
                      value: exportFormat,
                    }))}
                    minWidth={108}
                    className={classes.select}
                    value={
                      exportSelector
                        ? ({
                            label: exportSelector,
                            value: exportSelector,
                          } as CustomSelectItem)
                        : null
                    }
                    isDisabled={!exportFormats || isEmpty(exportFormats)}
                    isError={false}
                    newEditableLook
                  />
                  <Button
                    style={{
                      width: 88,
                      padding: 0,
                    }}
                    onClick={() =>
                      !loading && Number.isFinite(pmzId)
                        ? getExportData(
                            pmzId,
                            {
                              interval: graphState.interval,
                              range: sharedState?.range,
                              flowUnit: graphState.flowUnit,
                              pressureUnit: graphState.pressureUnit,
                            },
                            exportSelector
                          )
                        : null
                    }
                    loading={loading}
                    disabled={!Number.isFinite(pmzId) || !Boolean(exportSelector) || exportLoading || loading}
                  >
                    <Trans>Export</Trans>
                  </Button>
                </div>
              </LabeledValue>
            </div>
          </Collapse>
        </>
      </DialogModal>
    </>
  );
};
